import {RockBottomSymbolState} from "./RockBottomSymbolConfig";
import {IParsedStackedSymbolName, StackedSymbol} from "../../core/reel/stackedsymbol/StackedSymbol";
import {IBaseSymbol} from "../../core/symbol/BaseSymbol";
import {RockBottomGameConfig} from "../RockBottomGameConfig";
import {SpinePlayer} from "../../core/utils/SpinePlayer";
import {gsap} from "gsap";

export class RockBottomSymbol extends PIXI.Container implements IBaseSymbol {
    public symbolWidth: number = RockBottomGameConfig.SYMBOL_WIDTH;
    public symbolHeight: number = RockBottomGameConfig.SYMBOL_HEIGHT;
    public bottomPadding: number = RockBottomGameConfig.SYMBOL_BOTTOM_PADDING;

    public symbolName: string;
    public stackedSymbolName: IParsedStackedSymbolName;
    public reelId: number;
    public currSymbolSize: number = 1;

    protected _animation: SpinePlayer;
    protected _centerPosition: PIXI.Point;

    constructor(name: string, reelId: number, initState: RockBottomSymbolState) {
        super();
        this.name = name;
        this.symbolName = name;
        this.stackedSymbolName = StackedSymbol.parseStackedSymbolName(name, reelId);
        this.reelId = reelId;
        this.initAnimation();
        this.getStateAnimation(initState);
    }

    public get symbolStep(): number {
        return this.symbolHeight + this.bottomPadding;
    }

    public getStateAnimation(state: RockBottomSymbolState): gsap.core.Timeline {
        return this._animation.play({
            name: this.getStateTexture(state),
            loop: false,
            onComplete: () => {
                if (state === RockBottomSymbolState.SPLIT_TO_2) {
                    this.currSymbolSize = 2;
                } else if (state === RockBottomSymbolState.SPLIT_TO_4) {
                    this.currSymbolSize = 4;
                } else if (state === RockBottomSymbolState.SPLIT_TO_8) {
                    this.currSymbolSize = 8;
                } else {
                    //do nothing
                    //this.currSymbolSize = 1;
                }
            }
        });
    }

    public onRemove(): void {
        this.destroy({children: true});
    }

    public getGlobalPosition(): PIXI.Point {
        if (this.parent) {
            return new PIXI.Point(this.position.x + this.parent.x,
                this.position.y + this.parent.y);
        }
        return this.position;
    }

    public getTint(): void {
        this._animation.spine.tint = 0x555555;
    }

    protected initAnimation(): void {
        this._centerPosition = this.getCenterPosition();
        this._animation = new SpinePlayer(this.symbolName);
        this._animation.position.set(this._centerPosition.x, this._centerPosition.y);
        this.addChild(this._animation);
    }

    protected getCenterPosition(): PIXI.Point {
        return new PIXI.Point(0, 0);
    }

    protected getStateTexture(state?: RockBottomSymbolState): string {
        let texturePath = `normal`;
        switch (state) {
            case RockBottomSymbolState.NO_WIN:
                texturePath = `noWin`;
                break;
            case RockBottomSymbolState.NORMAL:
                texturePath = `normal`;
                break;
            case RockBottomSymbolState.LANDING:
                texturePath = `Landing`;
                break;
            case RockBottomSymbolState.SPIN:
                texturePath = `spin`;
                break;
            case RockBottomSymbolState.WIN:
                texturePath = `win`;
                break;
            case RockBottomSymbolState.WIN_TOGGLE:
                texturePath = `winToggle`;
                break;
            case RockBottomSymbolState.SPLIT_TO_2:
                texturePath = `xSToTwo`;
                break;
            case RockBottomSymbolState.SPLIT_TO_4:
                texturePath = `xSToFour`;
                break;
            case RockBottomSymbolState.SPLIT_TO_8:
                texturePath = `xSToEight`;
                break;
        }

        if (RockBottomGameConfig.MID_SYMS.includes(this.symbolName) &&
            (state === RockBottomSymbolState.NO_WIN ||
                state === RockBottomSymbolState.WIN ||
                state === RockBottomSymbolState.WIN_TOGGLE)) {
            texturePath = texturePath + "_" + this.currSymbolSize;
        }

        return texturePath;
    }
}